const SubModuleInfo = {

    SubModuleId: 0,
    Name: "",
    ModuleId: 0,
    Description: "",
    Active: true,
    UserId: 0,
    CreatedDate: new Date(),
    PartnerId: 0,
    QuestionCount: 0,
    encPartnerID: ""
};